<template>
  <custom-link
    :before_navigation="before_navigation"
    :route_name="is_placeholder ? '' : 'detail'"
    :wrap="'div'"
    :css_class="'suggestions__pad'"
    :as_default="get_config('guiSettings.openDetailNewTab', false)"
    :ref="`property:link-ref:${property.property_id}`"
  >
    <template #content>
      <vb-card
        :card="{
          image:
            property.thumbnail_url ||
            '/assets/images/common/statics/room_placeholder.png',
          image_fallback: '/assets/images/common/statics/room_placeholder.png',
          title: property.name,
          title_popover: property.name,
          style: {
            overflow: 'hidden',
          },
          subtitle: is_placeholder ? '---' : property_location,
          subtitle_class: 'text-info small semibold text-nowrap text-truncate',
          subtitle_icon: {
            name: 'pin',
            color: sass('info'),
            size: 13,
          },
          variant: 'vertical',
          ...card,
        }"
        @click_image="
          (e) => {
            if (!is_placeholder) {
              $refs[`property:link-ref:${property.property_id}`].navigate(
                e || {},
              );
            }
          }
        "
        @click_title="
          (e) => {
            if (!is_placeholder) {
              $refs[`property:link-ref:${property.property_id}`].navigate(
                e || {},
              );
            }
          }
        "
      >
        <template
          #title-badge
          v-if="property.ratings && property.ratings.property"
        >
          <div class="compact_pad__head-star">
            <b-form-rating
              no-border
              inline
              readonly
              size="sm"
              variant="secondary"
              :value="property.ratings.property.rating"
            />
          </div>
        </template>
        <template #badge>
          <score
            v-if="property.ratings && property.ratings.salabam_score"
            :direction="'row'"
            :rating="property.ratings.salabam_score"
            floating
          />
        </template>
        <template #footer>
          <div
            class="flex-grow-1 d-flex justify-content-between align-items-center small text-muted"
          >
            <div class="small">
              {{
                format_booking_dates_range({
                  date_start: checkin,
                  date_end: checkout,
                })
              }}
            </div>
            <div class="small d-flex align-items-center gap-2" style="gap: 5px">
              <span> a partire da </span>
              <rate-amount
                v-if="!is_placeholder"
                :prices="property_pricing"
                rate_only
              />
              <span v-else class="bold text-info" style="font-size: 23px">
                € ---.--
              </span>
            </div>
          </div>
        </template>
      </vb-card>
    </template>
  </custom-link>
</template>

<script>
import moment from "moment"
import { countries } from "@/resources";
import { format_booking_dates_range, normalize_search_property } from "@liveeps/utilities";
import Score from "@liveeps/components/atoms/score.vue";
import RateAmount from "@liveeps/components/blocks/rate-amount.vue";

export default {
  name: "invadobay-property-card",
  components: {
    score: Score,
    "rate-amount": RateAmount,
  },
  props: {
    property: Object,
    checkin: Object,
    checkout: Object,
    is_placeholder: Boolean,
    card: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    property_pricing() {
      const { rate = {} } = (this.property || {}).room || {};
      return rate.pricing;
    },
    property_location() {
      const { country = "", city = "" } = (this.property || {}).location || {};
      const { country_name = country } =
        countries.find((c) => c.country_code === country) || {};
      return [city, country_name].filter((text) => text.length).join(", ");
    },
  },
  methods: {
    format_booking_dates_range,
    before_navigation() {
      if (this.is_placeholder) {
        return;
      }
      try {
        // Sanity check set the dates specified for checkin and checkout as they may differ in booking-engine
        this.$store.commit("liveeps/checkin", moment(this.checkin).format("YYYY[-]MM[-]D"));
        this.$store.commit("liveeps/checkout", moment(this.checkout).format("YYYY[-]MM[-]D"));

        this.$store.commit("liveeps/update_selected_property", normalize_search_property(this.property));

        this.track_form({
          event: "invadobay-property-card:select",
          data: { type: "info" },
        })
      } catch (e) {
        this.log('ERROR [invadobay-property-card.before_navigation]: ', e)
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
